import Apple from '../../svg/PaymentLogos/apple.svg';
import Google from '../../svg/PaymentLogos/google.svg';
import Mastercard from '../../svg/PaymentLogos/mastercard.svg';
import Paypal from '../../svg/PaymentLogos/paypal.svg';
import Visa from '../../svg/PaymentLogos/visa.svg';
import styles from './PaymentLogoSection.module.css';

export const PaymentLogoSection = () => {
  return (
    <div className={styles.paymentLogoSection}>
      <p className={styles.heading}>Payments We Accept</p>
      <div className={styles.logoRow} style={{ color: '#4A4A4A' }}>
        <span style={{ width: '50px' }}>
          <Paypal />
        </span>
        <span style={{ width: '50px' }}>
          <Google />
        </span>
        <span style={{ width: '50px' }}>
          <Apple />
        </span>
        <span style={{ width: '50px' }}>
          <Visa />
        </span>
        <span style={{ width: '50px' }}>
          <Mastercard />
        </span>
      </div>
    </div>
  );
};
